
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect, SubmissionError} from 'react-redux'
import {createMerchantAndSite} from 'redux/modules/currentUser/actions'
import {showErrorToast} from 'redux/modules/ui/toaster/actions'
import {addSite, editSite} from 'redux/modules/sites/actions'
import {isWizardBusy} from 'redux/modules/wizard/selectors'
import {fetchIntegrations, markAsConnected} from 'redux/modules/integrations/actions'
import {openBillingPlansModal} from 'redux/modules/ui/modal/actions'
import {saveWizardState, clearStorage} from 'redux/modules/wizard/actions'
import {addMappingForCategory} from 'redux/modules/settings/actions'
import {getSite, getLastSite} from 'redux/modules/sites/selectors'
import {getCurrentUser, getCurrentMerchant} from 'redux/modules/currentUser/selectors'
import {getConnectedIntegrations} from 'redux/modules/integrations/selectors'
import {push as pushState} from 'react-router-redux'
import propsChanged from 'utils/propsChanged'
import Wizard from 'components/Wizard'
import Sidebar from 'components/Sidebar'
import sidebarPlaceholderImage from './images/sidemenu_placeholder.svg?external'
import Logo from 'components/Logo'
import Topbar from 'components/Topbar'
import Link from 'components/Link'

export class WizardView extends React.Component {
  static propTypes = {
    pushState: PropTypes.func,
    isBusy: PropTypes.bool,
    location: PropTypes.object,
    site: PropTypes.object,
    hasMerchantId: PropTypes.bool,
    channelsSettings: PropTypes.array,
    fetchIntegrations: PropTypes.func,
    openBillingPlansModal: PropTypes.func,
    saveWizardState: PropTypes.func,
    clearStorage: PropTypes.func,
    wizard: PropTypes.object,
    wizardFormValues: PropTypes.object,
    mappingFormValues: PropTypes.object,
    currentUser: PropTypes.object,
    queryError: PropTypes.string,
    newMode: PropTypes.string,
    merchant: PropTypes.object,
    params: PropTypes.object,
    createMerchantAndSite: PropTypes.func,
    addSite: PropTypes.func,
    editSite: PropTypes.func,
    markAsConnected: PropTypes.func,
    showErrorToast: PropTypes.func,
    embedded: PropTypes.string
  }

  componentDidMount(nextProps) {
    const {fetchIntegrations, hasMerchantId, embedded} = this.props
    if (hasMerchantId) {
      fetchIntegrations()
    }
    if (embedded) {
      window.addEventListener('message', this.onMessage)
    }
  }

  componentWillReceiveProps(nextProps) {
    const {fetchIntegrations} = nextProps

    if (propsChanged(this.props, nextProps, ['merchant'])) {
      fetchIntegrations()
    }
  }

  componentWillUnmount() {
    const {embedded} = this.props
    if (embedded) {
      window.removeEventListener('message', this.onMessage)
    }
  }

  render() {
    const {
      pushState,
      site,
      isBusy,
      channelsSettings,
      wizard,
      saveWizardState,
      wizardFormValues,
      mappingFormValues,
      openBillingPlansModal,
      clearStorage,
      currentUser,
      newMode,
      queryError,
      merchant,
      location,
      embedded
    } = this.props

    return (
      <div className='wizard-view'>
        <div className='wizard-view_topbar'>
          <Topbar>
            <div className='wizard-view_topbar-container'>
              <Logo />
              <Link to='/logout' className='wizard-view_logout'>Logout</Link>
            </div>
          </Topbar>
        </div>
        <div className='wizard-view_sidebar'>
          <Sidebar>
            <img
              width={107}
              height={480}
              className='wizard-view_sidebar-pic'
              src={sidebarPlaceholderImage}
            />
          </Sidebar>
        </div>
        <div className='wizard-view_content'>
          <Wizard
            onSiteCreationSubmit={this.onSiteCreationSubmit}
            onAddMappingForCategory={this.onAddMappingForCategory}
            onSaveWizardState={saveWizardState}
            onClearStorage={clearStorage}
            site={site}
            isBusy={isBusy}
            pushState={pushState}
            channels={channelsSettings}
            wizard={wizard}
            disableBillingPopup={!!embedded}
            disableSteps={embedded ? ['installation'] : []}
            disabledFields={embedded ? ['platform', 'url'] : []}
            embedded={!!embedded}
            currentUser={currentUser}
            queryError={queryError}
            newMode={newMode}
            merchant={merchant}
            location={location}
            openBillingPlansModal={openBillingPlansModal}
            formValues={{
              wizard: wizardFormValues,
              mappings: mappingFormValues
            }}
          />
        </div>
      </div>
    )
  }

  onAddMappingForCategory = ({mapping}, dispatch) => new Promise((resolve, reject) => {
    const {merchantSiteId} = this.props.params
    dispatch(addMappingForCategory({
      category: 'checkout-onepage',
      mapping
    }, merchantSiteId !== 'new' && merchantSiteId))
      .success(mapping => resolve({mapping}))
      .fail(err => {
        reject(new SubmissionError({_error: err.message}))
      })
  })

  onSiteCreationSubmit = creds => new Promise((resolve, reject) => {
    const {
      hasMerchantId, wizard: {edit}, params: {merchantSiteId},
      createMerchantAndSite, addSite, editSite,
      embedded
    } = this.props
    const editExistingSite = merchantSiteId && merchantSiteId !== 'new'

    const action = (edit || editExistingSite) ? editSite : (hasMerchantId ? addSite : createMerchantAndSite)
    return action({...creds, plan: 'trial', source: embedded || 'app-wizard'})
      .success(result => {
        window.parent.postMessage(`frontendId:${result.site.frontendId}`, '*')
        resolve(result)
      })
      .fail(reject)
  })

  onMessage = event => {
    const {markAsConnected, showErrorToast} = this.props
    const {protocol, host} = window.location
    if (event.origin !== `${protocol}//${host}`) return
    const data = (typeof event.data === 'string') ? event.data : ''
    if (!data) return
    const [messageType, serviceId] = data.split(':')

    if (messageType === 'costConnectorError') {
      showErrorToast('Something went wrong with cost connector, please try again later')
    } else if (messageType === 'costConnector' && serviceId) {
      markAsConnected(serviceId)
    }
  }
}

const mapStateToProps = (state, props) => {
  const {protocol, host} = window.location
  const {pathname, query = {}} = props.location
  const {embedded} = query
  const redirectURL = embedded ? `${protocol}//${host}/connectorCallback` : `${protocol}//${host}${pathname}`
  const {merchantSiteId} = props.params
  const isBusy = isWizardBusy(state)
  const connectedIntegrations = state.integrations.connectedIntegrations
  const channelsSettings = getConnectedIntegrations(state, redirectURL).map(i => ({
    connected: connectedIntegrations.includes(i.serviceId),
    ...i,
    authorizationURL: `${i.authorizationURL}?channel=${i.serviceId}`
  }))
  const wizard = state.wizard
  const hasMerchantId = !!state.currentUser.merchantId
  const wizardFormValues = state.currentUser.storage && state.currentUser.storage['form_wizard']
  const mappingFormValues = state.currentUser.storage && state.currentUser.storage['form_wizard-mappings']
  const currentUser = getCurrentUser(state)
  const queryError = query.error
  const site = merchantSiteId === 'new' ? null : (merchantSiteId ? getSite(state, merchantSiteId) : getLastSite(state))
  const merchant = getCurrentMerchant(state) || {}

  return {
    hasMerchantId,
    site,
    newMode: merchantSiteId,
    isBusy,
    channelsSettings,
    wizard,
    wizardFormValues,
    mappingFormValues,
    queryError,
    currentUser,
    merchant,
    embedded
  }
}
const mapDispatchToProps = {
  pushState,
  fetchIntegrations,
  markAsConnected,
  openBillingPlansModal,
  createMerchantAndSite,
  addMappingForCategory,
  addSite,
  saveWizardState,
  clearStorage,
  editSite,
  showErrorToast
}

export default connect(mapStateToProps, mapDispatchToProps)(WizardView)



// WEBPACK FOOTER //
// ./client/views/WizardView/index.js